module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-3-2.0304a77f.png";